import * as React from 'react';

// tslint:disable:max-line-length
export const HospitalIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="nonzero"
      d="M15 5h-4V1c0-.6-.4-1-1-1H6c-.6 0-1 .4-1 1v4H1c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-4h4c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1z"
    />
  </svg>
);
